import React from 'react'
import AdmStudentClub from '../../components/AdminTabs/AdminStudentClub/AdmStudentClub'

const StudentClub = () => {
  return (
    <div>
        <AdmStudentClub />
    </div>
  )
}

export default StudentClub